import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export default {
  state: () => state,
  actions,
  mutations,
  getters,
  namespaced: true
}
